import React from 'react';

import { Box, CircularProgress, InputLabel, Stack, TextField } from '@mui/material';

interface Props {
  vendorContribution: number;
  LEContribution: number;
  currencyCode: string;
  isConvertingCostPrice?: boolean;
}

export default function ShareOfRefund({
  vendorContribution,
  LEContribution,
  currencyCode,
  isConvertingCostPrice,
}: Props) {
  return (
    <Stack direction="row" spacing={2}>
      <Stack>
        <InputLabel
          htmlFor="vendor-contributions-input"
          sx={{
            fontWeight: 'bold',
          }}
        >
          Vendor Contribution ({currencyCode})
        </InputLabel>
        <Box sx={{ position: 'relative' }}>
          <TextField
            id="vendor-contributions-input"
            name="vendorContribution"
            value={isConvertingCostPrice ? '' : vendorContribution}
            disabled
            hiddenLabel
            type="number"
            size="small"
            variant="filled"
          />
          {isConvertingCostPrice && (
            <Box
              sx={{
                position: 'absolute',
                left: 8,
                top: '50%',
                transform: 'translateY(-50%)',
                pointerEvents: 'none',
              }}
            >
              <CircularProgress size={24} />
            </Box>
          )}
        </Box>
      </Stack>
      <Stack>
        <InputLabel
          htmlFor="le-contributions-input"
          sx={{
            fontWeight: 'bold',
          }}
        >
          LE Contribution ({currencyCode})
        </InputLabel>
        <Box sx={{ position: 'relative' }}>
          <TextField
            id="le-contributions-input"
            value={isConvertingCostPrice ? '' : LEContribution}
            name="LEContributions"
            type="number"
            size="small"
            variant="filled"
            hiddenLabel
            disabled
          />
          {isConvertingCostPrice && (
            <Box
              sx={{
                position: 'absolute',
                left: 8,
                top: '50%',
                transform: 'translateY(-50%)',
                pointerEvents: 'none',
              }}
            >
              <CircularProgress size={24} />
            </Box>
          )}
        </Box>
      </Stack>
    </Stack>
  );
}
